class DetailsDisclosure extends HTMLElement {
    constructor() {
        super();
        this.mainDetailsToggle = this.querySelector('details');
        this.addEventListener('keyup', this.onKeyUp.bind(this));
        document.addEventListener('click', this.onFocusOut.bind(this));
    }

    onKeyUp(event) {
        if (event.code.toUpperCase() !== 'ESCAPE') {
            return;
        }

        const openDetailsElement = event.target.closest('details[open]');
        if (!openDetailsElement) {
            return;
        }

        const summaryElement = openDetailsElement.querySelector('summary');
        this.close(openDetailsElement);
        summaryElement.focus();
    }

    onFocusOut(e) {
        const withBoundaries = e.composedPath().includes(this.mainDetailsToggle);

        if (!withBoundaries) {
            this.close(this.mainDetailsToggle);

            const children = this.mainDetailsToggle.querySelectorAll('details[open]');
            if (children) {
                children.forEach((item) => {
                    this.close(item);
                });
            }
        }
    }

    close(detailsElement) {
        try {
            detailsElement?.removeAttribute('open');
        } catch (error) {
           console.error(error);
        }
    }
}

customElements.define('details-disclosure', DetailsDisclosure);